import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { PrinterFilterTitles } from "../types";


export enum FilterTypes {
  ORDER_TYPE ="ORDER_TYPE",
  VENUE_AREA = "VENUE_AREA",
  COLLECTION_POINT = "COLLECTION_POINT",
  MENU = "MENU",
  SUBCATEGORY = "SUBCATEGORY"
}

export const printerFilterTitles: Record<string, PrinterFilterTitles> = {
  [FilterTypes.ORDER_TYPE]: {
    label: "printerSettings.form.printSpecificOrderTypes",
    secondLabel: "printerSettings.form.addOrderTypes",
    dialogTitle: "printerSettings.form.addOrderTypes",
    selectedItemsText: "printerSettings.form.orderTypesAreSelected",
    submitText: "printerSettings.form.confirm"
  },
  [FilterTypes.VENUE_AREA]: {
    label: "printerSettings.form.printOrdersFromSpecificVenueAreas",
    secondLabel: "printerSettings.form.addVenueAreas",
    dialogTitle: "printerSettings.form.printOrdersFromSpecificVenueAreas",
    selectedItemsText: "printerSettings.form.venueAreasSelected",
    submitText: "printerSettings.form.confirm"
  },
  [FilterTypes.COLLECTION_POINT]: {
    label: "printerSettings.form.printOrdersFromSpecificCollectionPoints",
    secondLabel: "printerSettings.form.addCollectionPoints",
    dialogTitle: "printerSettings.form.printOrdersFromSpecificCollectionPoints",
    selectedItemsText: "printerSettings.form.collectionPointsAreSelected",
    submitText: "printerSettings.form.confirm"
  },
  [FilterTypes.MENU]: {
    label: "printerSettings.form.printItemsFromSpecificMenus",
    secondLabel: "printerSettings.form.addMenus",
    dialogTitle: "printerSettings.form.printItemsFromSpecificMenus",
    selectedItemsText: "printerSettings.form.menusAreSelected",
    submitText: "printerSettings.form.confirm"
  },
  [FilterTypes.SUBCATEGORY]: {
    label: "printerSettings.form.printItemsFromSpecificSubcategorys",
    secondLabel: "printerSettings.form.addSubcategories",
    dialogTitle: "printerSettings.form.printItemsFromSpecificSubcategorys",
    selectedItemsText: "printerSettings.form.subcategoriesAreSelected",
    submitText: "printerSettings.form.confirm"
  },
}

export const filterConfig : Record<string, {
  APIDefinition: any,
  propNameToDisplay:string,
  subLabelKey:string,
  queryParams?:string
}> = {
  [FilterTypes.ORDER_TYPE]: {
    APIDefinition: APIExtensions.venueMerchant,
    propNameToDisplay:'name',
    subLabelKey:'name_internal',
  },
  [FilterTypes.VENUE_AREA]: {
    APIDefinition: APIExtensions.orderLocationGroups,
    propNameToDisplay:'name_public',
    subLabelKey:'name_internal'
  },
  [FilterTypes.COLLECTION_POINT]: {
    APIDefinition: APIExtensions.collectionPoints,
    propNameToDisplay:'name',
    subLabelKey:'name'
  },
  [FilterTypes.MENU]: {
    APIDefinition: APIExtensions.menus,
    propNameToDisplay:'name_public',
    subLabelKey:'name_internal'
  },
  [FilterTypes.SUBCATEGORY]: {
    APIDefinition: APIExtensions.menuItemSubcategories,
    propNameToDisplay:'subcategory_name',
    subLabelKey:'name_internal'
  },
}